import React, { useEffect, useState } from 'react'
import rotas from '../../../services/rotas'
import {
  PeopleAlt,
  ImportExport,
  MenuBook,
  Description
} from '@mui/icons-material'
import { object } from 'prop-types'
import DataCard from '../../../components/shared/dataCard'
import { ReactComponent as Book } from '../../../assets/book.svg'
import { Grid } from '@mui/material'
import DashboardsPostagens from '../../../services/http/dashboards/DashboardsPostagens'
import DashboardsEmprestimos from '../../../services/http/dashboards/DashboardsEmprestimos'
import { mapFilterKeys } from '../../../utils/filterUtils'
import monthInterval from '../functions/montInterval'
import { Leitores } from '../../../services/http'

const filterKeyMap = {
  biblioteca_id: 'leitor_biblioteca_id',
  funcao_id: 'leitor_funcao',
  departamento_id: 'leitor_departamento'
}

const GestaoDataCard = ({ filters }) => {
  const [livros, setLivros] = useState(0)
  const [emprestimos, setEmprestimos] = useState(0)
  const [users, setUsers] = useState(0)
  const [loading, setLoading] = useState(false)
  const [pages, setPages] = useState(0)
  const [plagiarism, setPlagiarism] = useState(0)
  const [filterGestao, setFilterGestao] = useState({})

  useEffect(() => {
    fetchAllData(filters)
  }, [filters])

  async function fetchAllData(filters) {
    setLoading(true)

    const filtroAdaptado = mapFilterKeys(filters, filterKeyMap)

    try {
      await Promise.all([
        // Livros: obras distintas postadas/lidas no período
        (async () => {
          const { data } = await DashboardsPostagens().show({
            group_by: 'obra_id',
            count: 'obra_id',
            status_postagem_id: [1, 2],
            per_page: -1,
            ...filtroAdaptado
          })
          setLivros(data.data.length)
        })(),

        // Leitores: leitores distintos com postagens no período
        (async () => {
          // const { data } = await DashboardsPostagens().show({
          //   group_by: 'leitor_id',
          //   count: 'leitor_id',
          //   status_postagem_id: [1, 2],
          //   per_page: -1,
          //   ...filtroAdaptado
          // })

          const { data } = await Leitores().show({
            'includes[]': 'user,biblioteca',
            'includes[user][ativo]': true,
            biblioteca_id: filters.biblioteca_id,
            funcao: filters.funcao_id,
            per_page: -1
          })

          setUsers(data.data.length)
        })(),

        // Empréstimos: empréstimos criados no período
        (async () => {
          const { data } = await DashboardsEmprestimos().show({
            group_by: 'status_emprestimo_id',
            count: 'emprestimo_id',
            per_page: -1,
            status_emprestimo_id: '1',
            created_at: monthInterval(filters.mes_id, filters.ano_id),
            leitor_biblioteca_id: filtroAdaptado.leitor_biblioteca_id,
            leitor_funcao: filtroAdaptado.leitor_funcao,
            leitor_departamento: filtroAdaptado.leitor_departamento
          })
          setEmprestimos(data.data[0]?.count_emprestimo_id || 0)
        })(),

        // Nº de Páginas: soma de páginas lidas no período
        (async () => {
          const { data } = await DashboardsPostagens().show({
            group_by: 'ano_id',
            count: 'numero_pagina',
            per_page: -1,
            status_postagem_id: [1, 2],
            ...filtroAdaptado
          })
          setPages(data.data[0]?.sum_numero_pagina || 0)
        })(),

        // Plágio: postagens reprovadas no período
        (async () => {
          const { data } = await DashboardsPostagens().show({
            group_by: 'status_postagem_descricao',
            count: 'status_postagem_descricao',
            status_postagem_id: [3],
            per_page: -1,
            ...filtroAdaptado
          })
          setPlagiarism(data.data[0]?.count_status_postagem_descricao || 0)
        })()
      ])
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }

    setFilterGestao({
      ano_id: filters.ano_id,
      mes_id: filters.mes_id,
      status_postagem_id: 3,
      'includes[leitor.biblioteca][id]': filters.biblioteca_id
    })
  }

  const data = [
    {
      legend: 'Livros',
      value: livros,
      Icon: MenuBook,
      color: '#EA9027',
      clickable: false,
      simplify: true
    },
    {
      legend: 'Leitores',
      value: users,
      Icon: PeopleAlt,
      color: '#9D2AAF',
      clickable: false,
      simplify: true
    },
    {
      legend: 'Empréstimos',
      value: emprestimos,
      Icon: ImportExport,
      color: '#185273',
      clickable: false,
      simplify: true
    },
    {
      legend: 'Nº de Páginas',
      value: pages,
      Icon: Description,
      color: 'green',
      clickable: false,
      simplify: true
    },
    {
      legend: 'Plágio',
      value: plagiarism,
      Icon: Book,
      color: '#D32F2F',
      clickable: true,
      route: rotas.postagens
    }
  ]

  return (
    <>
      {data.map((item, index) => (
        <Grid item xs={5.6} sm={2.2} key={index} sx={{ marginTop: '10px' }}>
          <DataCard
            loading={loading}
            Icon={item.Icon}
            legend={item.legend}
            value={item.value}
            color={item.color}
            simplify={item.simplify}
            route={item.route}
            filterGestao={filterGestao}
          />
        </Grid>
      ))}
    </>
  )
}

GestaoDataCard.propTypes = {
  filters: object
}

export default GestaoDataCard
